// src/data/mockContactData.ts
export const mockContactInfo = {
  address: "Niketan Marg, Charkhaal, Dillibazaar, Kathmandu, Nepal",
  phone: "+977-14547745, 9801890407",
  email: "support@dghub.io, support@digihub.com.np",
  hours: "Sunday – Friday: 9:30 AM – 6:00 PM",
  mapUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4295.826200105297!2d85.32923146609049!3d27.70715178216643!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb19007e5f7429%3A0x4cd77c5bd210d532!2sDigi%20Hub!5e1!3m2!1sen!2snp!4v1764585918643!5m2!1sen!2snp",
  socialLinks: [
    {
      name: "LinkedIn",
      url: "https://linkedin.com/company/digihub",
      icon: "LinkedIn",
    },
    {
      name: "Facebook",
      url: "https://www.facebook.com/share/1CnUt96sQj/",
      icon: "Facebook",
    },
    {
      name: "Instagram",
      url: "https://www.instagram.com/digihub_np/",
      icon: "Instagram",
    },
    {
      name: "Youtube",
      url: "https://www.youtube.com/@DigiHub-2016",
      icon: "Youtube",
    },
  ],
};
